"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = require("../tools/Widget");
var jquery_1 = __importDefault(require("jquery"));
var Collapsible = (function (_super) {
    __extends(Collapsible, _super);
    function Collapsible(node, config) {
        var _this = _super.call(this, node, config) || this;
        _this.addLabels();
        _this.close();
        return _this;
    }
    Collapsible.prototype.defaultConfig = function () {
        return {
            size: 5,
            closelabel: 'Show less',
            openlabel: 'Show more'
        };
    };
    Collapsible.prototype.dataConfig = function () {
        return ['size', 'closelabel', 'openlabel'];
    };
    Collapsible.prototype.open = function () {
        this.el.stop();
        this.el.slideDown(200);
        this.showLess.removeClass('hidden');
        this.showMore.addClass('hidden');
    };
    Collapsible.prototype.close = function () {
        this.el.stop();
        this.el.slideUp(200);
        this.showLess.addClass('hidden');
        this.showMore.removeClass('hidden');
    };
    Collapsible.prototype.addLabels = function () {
        var config = this.config;
        this.showMore = jquery_1.default("<span class='show-more'>" + config.openlabel + "</span>").addClass('hidden');
        this.showLess = jquery_1.default("<span class='show-less'>" + config.closelabel + "</span>").addClass('hidden');
        this.showMore.click(jquery_1.default.proxy(this.open, this));
        this.showLess.click(jquery_1.default.proxy(this.close, this));
        this.el.after(this.showMore);
        this.el.after(this.showLess);
    };
    return Collapsible;
}(Widget_1.Widget));
exports.Collapsible = Collapsible;
